import { render, staticRenderFns } from "./MoveIn.vue?vue&type=template&id=2a6d0073&scoped=true"
import script from "./MoveIn.vue?vue&type=script&lang=js"
export * from "./MoveIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d0073",
  null
  
)

export default component.exports